import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import usePermissions from "../hook/usePermissions";
import { getFirstPermittedRoute } from "../helper/PermissionHelper";

const AccessDeniedLayer = () => {
  const { hasPermission, loading } = usePermissions();

  const firstAllowedRoute = !loading ? getFirstPermittedRoute(hasPermission) : "/";

  return (
    <div 
      className="d-flex align-items-center justify-content-center vh-100 p-24"
      style={{ backgroundColor: "#f6f4ee" }}
    >
      {/* Main Restricted Access Card */}
      <div 
        className="text-center bg-white p-40"
        style={{
          borderRadius: "24px",
          maxWidth: "440px",
          width: "100%",
          boxShadow: "0 20px 40px -10px rgba(0, 0, 0, 0.06)"
        }}
      >
        <div 
          className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-20"
          style={{ width: "72px", height: "72px", backgroundColor: "#fdeef0" }}
        >
          <Icon icon="solar:shield-warning-linear" style={{ fontSize: "36px", color: "#d93939" }} />
        </div>

        <h5 className="fw-bold mb-12 text-dark" style={{ fontSize: "18px" }}>
          Access Restricted
        </h5>

        <p 
          style={{ color: "#64748b", fontSize: "14px", lineHeight: "1.6", maxWidth: "340px", margin: "0 auto 28px" }}
        >
          You do not have permission to view this module. Please contact your system administrator to request access.
        </p>

        <Link
          to={firstAllowedRoute}
          className="btn d-inline-flex align-items-center justify-content-center gap-2 text-white fw-medium shadow-sm"
          style={{
            backgroundColor: "#364e3d",
            borderColor: "#364e3d",
            borderRadius: "50px",
            fontSize: "14px",
            padding: "10px 26px",
            transition: "all 0.2s ease"
          }}
        >
          <Icon icon="solar:home-angle-linear" style={{ fontSize: "18px" }} />
          <span>Go to Home</span>
        </Link>
      </div>
    </div>
  );
};

export default AccessDeniedLayer;
